export default "__VITE_ASSET__DvGlQ$vg__"